class AccordionElement extends HTMLElement {

  constructor() {
    super();
    this.accordionTrigger = this.querySelector('accordion-trigger');
    this.accordionContent = this.querySelector('accordion-content');
  }

  connectedCallback() {
    this.accordionTrigger.addEventListener('click', this.toggleAccordion.bind(this));
    document.addEventListener('click', this.closeAccordion.bind(this));
  }

  toggleAccordion() {
    this.accordionTrigger.ariaExpanded = this.accordionTrigger.ariaExpanded === 'true' ? 'false' : 'true';
    this.accordionContent.style.height = this.accordionTrigger.ariaExpanded !== 'false' ? this.accordionContent.scrollHeight + 'px' : '0px';
  }
  closeAccordion(event) {
    if (!this.contains(event.target)) {
      this.accordionTrigger.ariaExpanded = 'false';
      this.accordionContent.style.height = '0px';
    }
  }

  disconnectedCallback() {
    this.accordionTrigger.removeEventListener('click', this.toggleAccordion.bind(this));
    document.removeEventListener('click', this.closeAccordion.bind(this));
  }
}

customElements.define('accordion-element', AccordionElement);